import React from 'react';

import { Box, Hidden } from '@material-ui/core';
import { titleTemplateFormatted } from 'helpers/template-module';

import Container from './styles';

import { HelpButton } from 'components';
import { TypographyCN } from 'components/atoms/Typograph';
import { HeaderPathsProps } from 'components/DashboardCN';
import { useMobile } from 'utils/useMobile';
import { useRouter } from 'utils/useRouter';

type Props = {
  title: string;
  subtitle?: React.ReactNode;
  height?: string;
  titleProps?: React.ComponentProps<typeof TypographyCN>;
  subtitleProps?: React.ComponentProps<typeof TypographyCN>;
  style?: React.CSSProperties;
  className?: string;
  actionComponent?: React.ReactNode;
  disableHelpButton?: boolean;
  footerComponent?: React.ReactNode;
  justifyContent?: string;
  boxOneProps?: React.ComponentProps<typeof Box>;
  boxTwoProps?: React.ComponentProps<typeof Box>;
  isShipment?: boolean;
  headerPath?: HeaderPathsProps[];
};

export function PageTitle({
  title,
  subtitle,
  titleProps,
  actionComponent,
  subtitleProps,
  height,
  style,
  className,
  disableHelpButton,
  footerComponent,
  justifyContent,
  boxOneProps,
  boxTwoProps,
  isShipment,
  headerPath,
}: Props) {
  const isMobile = useMobile();
  const isWide = useMobile(1250);
  const { pathname, push } = useRouter();

  const isVisualize = pathname.includes('ver');
  const isEdit = pathname.includes('editar');
  const isAdd = pathname.includes('cadastro');
  const sizePathname = pathname.split('/').filter(text => text != '').length;

  return (
    <Container height={height} {...{ style, className }}>
      <Box
        display="flex"
        flexDirection={'row'}
        alignItems={isWide ? 'flex-start' : 'center'}
        justifyContent="flex-start"
        width="100%"
        style={{ gap: '1rem' }}
        {...boxOneProps}
      >
        {/* <Hidden mdDown> */}
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          alignItems="center"
          width={isVisualize || isEdit || isAdd ? 'auto' : '100%'}
        >
          {headerPath &&
            headerPath?.map((path, index) => {
              const isLast = headerPath.length - 1 === index;
              const fontSizeDesk = path?.actualRoute ? 'desk-variation-one' : 'desk-simple';

              function handleRoutePath(url = '/') {
                if (path?.actualRoute) return;

                push(url);
              }

              return (
                <Box
                  key={index}
                  onClick={() => handleRoutePath(path.destination)}
                  style={{
                    cursor: path?.actualRoute ? 'default' : 'pointer',
                  }}
                >
                  <TypographyCN
                    fontType={path?.actualRoute ? 'Proxima Nova' : 'Roboto'}
                    size={isMobile ? 'mob-simple' : fontSizeDesk}
                    style={{
                      fontWeight: path?.actualRoute ? 700 : 500,
                      textAlign: !isShipment ? 'left' : undefined,
                      marginLeft: 2,
                      whiteSpace: 'nowrap',
                      color: path?.actualRoute ? '#0370B2' : '#757575',
                    }}
                    // {...titleProps}
                  >
                    {path.label}
                    {!isLast && ' / '}
                  </TypographyCN>
                </Box>
              );
            })}
        </Box>
        {/* </Hidden> */}
        {/* {!isMobile && !disableHelpButton && !isShipment && <HelpButton />} */}
      </Box>
      {/* <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        {...boxTwoProps}
      >
        <TypographyCN
          size="desk-simple"
          weight="simple"
          style={{
            textAlign: 'left',
          }}
          {...subtitleProps}
        >
          {subtitle}
        </TypographyCN>
        {actionComponent}
      </Box> */}
      {/* <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent={justifyContent || 'flex-start'}
        width="100%"
      >
        {footerComponent}
      </Box> */}
    </Container>
  );
}
